import './acl';
import './components/uc-element-sorter';
import './components/uc-theme-picker';
import './components/uc-milestone-manager';
import './components/uc-media-upload';
import './components/uc-free-product-manager';
import './page/uc-config-page';
import './page/uc-milestones-page';
import './page/uc-free-products-page';
import './page/uc-cross-sell-rules-page';

// Snippets are NOT imported/passed here — Shopware auto-loads any
// <locale>.json files it finds in a folder literally named `snippet`
// alongside a registered module (see ./snippet/de-DE.json, en-GB.json).
// Passing them explicitly via `snippets:` below is forbidden by Shopware's
// own admin lint rule (no-snippet-import) since it bloats the bundle with
// data that's already loaded automatically.
Shopware.Module.register('sellops-ultimate-cart', {
    type: 'plugin',
    name: 'Ultimate Cart',
    title: 'sellops-ultimate-cart.general.mainMenuLabel',
    description: 'sellops-ultimate-cart.general.description',
    color: '#0f69c4',
    icon: 'regular-shopping-cart',

    navigation: [
        {
            id: 'sellops-ultimate-cart',
            label: 'sellops-ultimate-cart.general.mainMenuLabel',
            color: '#0f69c4',
            icon: 'regular-shopping-cart',
            path: 'sellops.ultimate.cart.config',
            parent: 'sw-extension',
            position: 100,
        },
        {
            id: 'sellops-ultimate-cart-config',
            label: 'sellops-ultimate-cart.general.configMenuLabel',
            path: 'sellops.ultimate.cart.config',
            parent: 'sellops-ultimate-cart',
            position: 10,
        },
        {
            id: 'sellops-ultimate-cart-milestones',
            label: 'sellops-ultimate-cart.milestones.navLabel',
            path: 'sellops.ultimate.cart.milestones',
            parent: 'sellops-ultimate-cart',
            position: 20,
        },
        {
            id: 'sellops-ultimate-cart-freeproducts',
            label: 'sellops-ultimate-cart.freeProducts.pageTitle',
            path: 'sellops.ultimate.cart.freeproducts',
            parent: 'sellops-ultimate-cart',
            position: 30,
        },
        {
            id: 'sellops-ultimate-cart-crosssellrules',
            label: 'sellops-ultimate-cart.crossSellRules.navLabel',
            path: 'sellops.ultimate.cart.crosssellrules',
            parent: 'sellops-ultimate-cart',
            position: 40,
        },
    ],

    routes: {
        config: {
            component: 'uc-config-page',
            path: 'config',
            meta: {
                privilege: 'sellops_ultimate_cart.viewer',
            },
        },
        milestones: {
            component: 'uc-milestones-page',
            path: 'milestones',
            meta: {
                privilege: 'sellops_ultimate_cart.viewer',
            },
        },
        freeproducts: {
            component: 'uc-free-products-page',
            path: 'freeproducts',
            meta: {
                privilege: 'sellops_ultimate_cart.viewer',
            },
        },
        crosssellrules: {
            component: 'uc-cross-sell-rules-page',
            path: 'crosssellrules',
            meta: {
                privilege: 'sellops_ultimate_cart.viewer',
            },
        },
    },
});
